module.exports = __webpack_public_path__ + "img/26_121.91f1bc0b.png";